module.exports = __webpack_public_path__ + "static/img/localization-map-marker.c3ba1ba5.svg";